/* Nové leady — JEDNO místo, kde poradce vidí, co mu spadlo z webu.
 *
 * Majitel 18. 10. 2026: „složka Leads nový.. že když spadne lead, tak to tam je".
 * Backend (lib/prijem_leadu.py) u každého leadu z veřejného webu zapíše
 * `lead_at` + `lead_zdroj` — i u kontaktu, který už v CRM byl (nový zájem).
 * Nový = přišel za posledních 30 dní a od té doby se mu poradce neozval
 * (žádný `last_call` ze dne příchodu nebo pozdějšího).
 *
 * Starší kontakty bez `lead_at` (před 18. 10. 2026) se berou podle `created_at`,
 * ale jen když jsou z webu (zdroj Leadovač/Trychtýř/Doporučení/web) — ruční
 * kontakty z Projektu 100 sem nepatří.
 *
 * Modul je čistý (bez Reactu a API), sdílí ho Zrcadlo volání i zvoneček.
 */
import { popisZdroje } from "./puvodLeadu";
import { dnesISOLokalne } from "./frontaVolani";

export const NOVY_LEAD_DNI = 30;
const WEBOVE_TYPY = ["leadovac", "trychtyr", "doporuceni", "web"];
const txt = (v) => (typeof v === "string" ? v : "");

/** Kdy lead přišel (ms) nebo null. */
export function prisel(c) {
  if (!c || typeof c !== "object") return null;
  const raw = c.lead_at || (WEBOVE_TYPY.includes(popisZdroje(c.source).typ) ? c.created_at : null);
  if (!raw) return null;
  const ms = new Date(raw).getTime();
  return isNaN(ms) ? null : ms;
}

/** Je kontakt nový, dosud neobvolaný lead? */
export function jeNovyLead(c, ted = new Date()) {
  const ms = prisel(c);
  if (ms == null) return false;
  if (txt(c.stage) === "lost") return false;
  const stari = ted.getTime() - ms;
  if (stari < 0 || stari > NOVY_LEAD_DNI * 86400000) return false;
  // Starší kontakt bez lead_at: jakýkoli výsledek hovoru = vyřízeno.
  if (!c.lead_at && (c.last_call || c.call_status)) return false;
  const den = dnesISOLokalne(new Date(ms));
  return !(txt(c.last_call) && txt(c.last_call) >= den);
}

/** Nové leady od NEJNOVĚJŠÍHO — poradce má volat dokud je zájem čerstvý. */
export function noveLeady(contacts, ted = new Date()) {
  const list = Array.isArray(contacts) ? contacts.filter((x) => x && typeof x === "object") : [];
  return list
    .filter((c) => jeNovyLead(c, ted))
    .sort((a, b) => prisel(b) - prisel(a));
}

/** Odkud poslední zájem — u nového zájmu existujícího kontaktu se liší od `source`. */
export const zdrojLeadu = (c) => c?.lead_zdroj || c?.source || "";

/** Diář: telefonát s klientem, datum a čas vybere poradce (nic se nevymýšlí). */
export function odkazZavolatDoDiare(contact) {
  const jmeno = [contact?.name, contact?.surname].filter(Boolean).join(" ").trim();
  const p = new URLSearchParams({ newActivity: "1", type: "telefonat", contact_id: String(contact?.id ?? "") });
  p.set("title", jmeno ? `Zavolat — ${jmeno}` : "Zavolat");
  p.set("potom", "/crm/calls?f=nove");
  return `/diar?${p.toString()}`;
}
